export const passwordChannels = {
  Back: 'Volver',
  'We will send you a verification code to confirm your identity':
    'Le enviaremos un código de verificación para confirmar su identidad',
  'How would you like to receive your code?': '¿Cómo desea recibir su código?',
  'Error!': '¡Error!',
  'Your account does not have any valid contact methods registered.':
    'Su cuenta no tiene ningún método de contacto válido registrado.',
  'Password reset code sent successfully!':
    '¡Código de restablecimiento de contraseña enviado con éxito!',
  'There was a problem sending your code':
    'Hubo un problema al enviar su código',
};
